var isInside = true, resultWidth = 0, resultWidthEighths = 0, resultLength = 0, resultLengthEighths = 0, showWidth = 0, showLength = 0;
$('.popupContainer.measurement').on('click', function () {
  setThemeGuideOpen(this, false);
})

$('.popupContainer.measurement .popupBox .popupTitle svg').on('click', function () {
  $(this).closest('.popupContainer').click();
})

$('.popupContainer.measurement .popupBox').on('click', function (event) {
  event.stopPropagation();
})

$('.popupContainer.measurement .popupBox .popupBody .step > div').on('click', function () {
  if ($(this).attr('disabled') == 'disabled') {
    return;
  }

  scrollChangeNum({
    ele: '.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList',
    direction: 'horizontal',
    num: $(this).index()
  });

  if ($(this).index() + 1 >= $('.popupContainer.measurement .popupBox .popupBody .step > div').length) {
    resultChange();
  }
  // 底部按钮展示
  $('.btnList .btns').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'none' : 'flex');
  $('.btnList > .btn').css('display', $(this).index() + 1 < $('.popupContainer.measurement .popupBox .popupBody .step > div').length ? 'flex' : 'none');
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').on('click', function () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());
  var inputType = false, optionType = false;

  if (currentStep.find('.option:not([col="1"])').length > 0) {
    optionType = currentStep.find('.optionItem.active').length == 0;
  }

  $.each(currentStep.find('input[required]'), function (i, item) {
    $(item).css('border-color', $(item).val().length == 0 || $(item).val() == 0 ? '#b11500' : '#1F1F1F');
    if ($(item).val().length == 0 || $(item).val() == 0) {
      inputType = true;
    }
  });

  currentStep.find('.option').css('border-color', optionType ? '#b11500' : 'transparent');

  if (inputType || optionType) {
    return;
  }

  stepChange();
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList .selectBox .selectName').on('click', function () {
  var type = $(this).hasClass('active');
  if (type) {
    $(this).removeClass('active');
  } else {
    $(this).addClass('active');
  }
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList .selectBox .selectList > div').on('click', function () {
  var $selectBox = $(this).closest('.selectBox');
  var $input = $(this).find('input');
  $input.prop('checked', true);
  $selectBox.find('.selectName').text($input.val()).removeClass('active');
})

function stepChange () {
  var current = $('.popupContainer.measurement .popupBox .popupBody .step > div.active');
  var currentStep = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(current.index());

  // true: Inside; false: Outside;
  isInside = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(1) .optionItem.active').attr('data-value') == 'true';
  if (isInside) {
    $('.popupContainer.measurement .popupBox input[data-type="widthA"]').val(0);
    $('.popupContainer.measurement .popupBox input[data-type="widthB"]').val(0);
  }
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(2) .first .msg span').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .optionItem[data-value="true"]').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .optionItem[data-value="false"]').css('display', !isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .inputList > .msg').text(isInside ? 'Measure the left, center and right portion of the inside frame and use the longest height measurement.' : `Measure ${Math.floor(4 * lengthRate)}-${Math.floor(8 * lengthRate)}${unitType} from above the window, down to where you want the shade to sit.`);

  if (!isInside && currentStep.find('.first').length > 0 && currentStep.find('.first').css('display') != 'none') {
    // Outside
    currentStep.find('.first').css('display', 'none');
    currentStep.find('.branch').css('display', 'flex');
    return;
  }

  current.next().removeAttr('disabled').click();
  $('.nextStep').attr('click-data', `SizeGuideStep${current.next().index() + 1}`);
}

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 1
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? $(list.ele)[0].scrollHeight : $(list.ele)[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? $(list.ele).find('>*:first-of-type').outerHeight() : $(list.ele).find('>*:first-of-type').outerWidth();
  // 子元素间距
  var elechilrenSpace = (eleScroll - elechilrenSize * $(list.ele).find('>*').length) / ($(list.ele).find('>*').length - 1);

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.direction == 'vertical') {
    $(list.ele).animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    $(list.ele).animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }

  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.first').css('display', 'flex');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox').eq(list.num).find('.branch').css('display', 'none');

  $('.popupContainer.measurement .popupBox .popupBody .step > div').removeClass('active');
  $('.popupContainer.measurement .popupBox .popupBody .step > div').eq(list.num).removeAttr('disabled').addClass('active');
}

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('change', function () {
  var widthType = false, lengthType = false, text = Math.round(Math.abs($(this).val()));

  // if (!isSunShade) {
  //   const liftItem = liftTypeLength[$('[name="properties[Lift Type]"]:checked').val()];
  //   if (liftItem) {
  //     const sizeType = $(this).attr('data-type') == 'width' ? 'Width' : 'Length';
  //     if (text < liftItem[`min${sizeType}`]) {
  //       text = liftItem[`min${sizeType}`];
  //     }
  //     if (text > liftItem[`max${sizeType}`]) {
  //       text = liftItem[`max${sizeType}`];
  //     }

  //     if (isInside && text <= liftItem[`min${sizeType}`]) {
  //       text += 1;
  //     }
  //   }
  // }

  $(this).val(text);
})

$('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox .optionList .inputList input').on('keydown', function () {
  if (event.which == 13) {
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .nextStep').click();
  }
})

$('.popupContainer.measurement .popupBox .btns .btn').on('click', function () {
  var type = $(this).attr('type');

  if (type == 'white') {
    // reset
    $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .optionItem').removeClass('active');
    $('.popupContainer.measurement .popupBox input').val('');
    $('.popupContainer.measurement .popupBox .popupBody .step > div:not(:first-of-type)').removeClass('active').attr('disabled', true);
    $('.popupContainer.measurement .popupBox .popupBody .step > div:first-of-type').click();
  }

  if (type == 'black' && $('.outChangeMsg').css('display') == 'none') {
    // shop now
    $(`input[name="properties[Installation Method]"][value="${isInside ? 'Inside' : 'Outside'}"] + label`).click();
    $('select[name*="Panel Width"]').closest('.selector-wrapper').find('.selectInput').val(`${showWidth}${ unitType }`);
    $('select[name*="Panel Length"]').closest('.selector-wrapper').find('.selectInput').val(`${showLength}${ unitType }`);
    $('select[name*="Panel Width"]').val(`${resultWidth}"`);
    $('select[name*="Panel Length"]').val(`${resultLength}"`).change();
    $(`.Fraction input[name*="Width Fraction"][value='${resultWidthEighths}"']`).closest('div').click();
    $(`.Fraction input[name*="Length Fraction"][value='${resultLengthEighths}"']`).closest('div').click();
    $(this).closest('.popupContainer').click();
  }
})

$('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox .option .optionItem .itemBox').on('click', function () {
  $(this).closest('.option').css('border-color', 'transparent');
  $(this).closest('.option').find('.optionItem').removeClass('active');
  $(this).parent().addClass('active');

  // true: Inside; false: Outside;
  isInside = $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(1) .optionItem.active').attr('data-value') == 'true';
  if (isInside) {
    $('.popupContainer.measurement .popupBox input[data-type="widthA"]').val(0);
    $('.popupContainer.measurement .popupBox input[data-type="widthB"]').val(0);
  }
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(2) .first .msg span').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .optionItem[data-value="true"]').css('display', isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .optionItem[data-value="false"]').css('display', !isInside ? 'flex' : 'none');
  $('.popupContainer.measurement .popupBox .popupBody .stepContainer .stepList .stepBox:nth-of-type(3) .inputList > .msg').text(isInside ? 'Measure the left, center and right portion of the inside frame and use the longest height measurement.' : 'Measure 4-8” from above the window, down to where you want the shade to sit.');
})

function resultChange () {
  var windowWidth = 0, windowLength = 0;

  var width = parseInt($('.popupContainer.measurement .popupBox input[data-type="width"]').val() || 0),
    widthEighths = $('.popupContainer.measurement .popupBox input[name="width_Eighths"]:checked').val() || '0"',
    widthA = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthA"]').val() || 0),
    widthB = parseInt($('.popupContainer.measurement .popupBox input[data-type="widthB"]').val() || 0);
  var height = parseInt($('.popupContainer.measurement .popupBox input[data-type="height"]').val() || 0),
    heightEighths = $('.popupContainer.measurement .popupBox input[name="height_Eighths"]:checked').val() || '0"';

  windowWidth = width + widthA + widthB;
  windowLength = height;

  resultWidth = showWidth = windowWidth;
  resultLength = showLength = windowLength;
  resultWidthEighths = widthEighths.split('"')[0];
  resultLengthEighths = heightEighths.split('"')[0];

  if (isInside) {
    if (unitType == '"') {
      var decimalResult = 0;
      if (resultWidthEighths != '0') {
        decimalResult = fractionToDecimal(resultWidthEighths);
      }

      var width = resultWidth + decimalResult - 0.5;
      resultWidth = Math.floor(width);
      resultWidthEighths = `${width - resultWidth != 0 ? decimalToFraction(width - resultWidth) : 0}`;
    } else if (unitType == 'cm') {
      resultWidth -= 1.5;
    }
  }

  showWidth = resultWidth;
  showLength = resultLength;

  if (lengthRate != 1) {
    resultWidth = Math.ceil(resultWidth / lengthRate);
    resultLength = Math.ceil(resultLength / lengthRate);
    showWidth = Math.ceil(resultWidth * lengthRate);
    showLength = Math.ceil(resultLength * lengthRate);
  }

  var widthType = false, lengthType = false;
  // 获取当前选中的升降类型配置
  const selectedType = $('[name="properties[Lift Type]"]:checked').val();
  const liftTypeList = liftTypeLength[selectedType];
  // 创建深拷贝（避免修改原始配置）
  const liftItem = {
    minWidth: liftTypeList.minWidth,
    maxWidth: liftTypeList.maxWidth,
    minLength: liftTypeList.minLength,
    maxLength: liftTypeList.maxLength
  };

  if (!isSunShade) {
    // 单位转换
    if (unitType !== "$") {
      const rate = lengthRate;
      liftItem.minWidth = Math.ceil(liftTypeList.minWidth * rate);
      liftItem.minLength = Math.ceil(liftTypeList.minLength * rate);
      liftItem.maxWidth = Math.ceil(liftTypeList.maxWidth * rate);
      liftItem.maxLength = Math.ceil(liftTypeList.maxLength * rate);
    }
  }
  widthType = showWidth >= liftItem.minWidth && showWidth <= liftItem.maxWidth;
  lengthType = showLength >= liftItem.minLength && showLength <= liftItem.maxLength;

  $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').attr('disabled', !widthType || !lengthType);
  $('.outChangeMsg').css('display', !widthType || !lengthType ? 'block' : 'none');
  $('.resultSize').html(`<p>${isInside ? 'Inside' : 'Outside'}MOUNT</p><p><span>${showWidth} ${resultWidthEighths != '0' ? resultWidthEighths : ''}${ unitType }</span>WIDTH</p><p><span>${showLength} ${resultLengthEighths != '0' ? resultLengthEighths : ''}${ unitType }</span>LENGTH</p>`);
}
